/*eslint-disable*/
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
const urlBase = `${process.env.API_URL}/subclient`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchSubclientAlerta = async (subclientId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/alerta/${subclientId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);
  return res.success;
};
export const createAlerta = async (subclientId, alertaInfo) => {
  const auth = `Bearer ${getToken()}`;
  alertaInfo.subclientId = subclientId;
  delete alertaInfo.id;
  let res = await fetch(readUrl(`/alerta`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(alertaInfo),
  });

  res = await parseJSON(res);

  return res.success;
};
export const editarAlerta = async (subclientId, alertaInfo) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/alerta/${subclientId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(alertaInfo),
  });

  res = await parseJSON(res);

  return res.success;
};
export const eliminarAlerta = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/alerta?id=${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
export const fetchAlertaCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/categories`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success.result;
};
